var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "780px" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("check")]),
              _vm._v(" Aprobar papeleta con cargo a vacación\n      "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "py-0" },
            [
              _c(
                "v-container",
                {
                  staticClass: "pa-0",
                  staticStyle: { "min-width": "100%" },
                  attrs: { "grid-list-md": "" }
                },
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", { staticClass: "texto" }, [
                          _c("strong", [_vm._v("Número:")]),
                          _vm._v(
                            " " + _vm._s(_vm.permiso.numero) + "\n            "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", { staticClass: "texto" }, [
                          _c("strong", [_vm._v("Funcionario:")]),
                          _vm._v(
                            " " + _vm._s(_vm.permiso.nombres) + "\n            "
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c("h3", { staticClass: "subtitulo-uso" }, [
                          _c("strong", [_vm._v("Detalle de vacación ")])
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass:
                              "elevation-1 tabla-comprimida-light celda-comprimida",
                            attrs: {
                              items: _vm.permiso_detalles,
                              "hide-actions": "",
                              headers: _vm.headers
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.fecha_desde) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.fecha_hasta) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.hora_desde))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.hora_hasta))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.dias))]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-flex", { attrs: { xs12: "" } }, [
                    _c("h3", { staticClass: "subtitulo-uso" }, [
                      _c("strong", [
                        _vm._v("Seguimiento solicitud con cargo a vacación")
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-data-table", {
                            staticClass:
                              "elevation-1 tabla-comprimida-light celda-comprimida",
                            attrs: {
                              headers: _vm.headers_seg_detalle,
                              items: _vm.detalle_seguimiento,
                              "hide-actions": ""
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "items",
                                fn: function(props) {
                                  return [
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(props.item.fecha_registro) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              props.item.estado ==
                                                "Aprobado. Inmediato Superior Jerárquico"
                                                ? "Aprobado"
                                                : props.item.estado
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.usuario))]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      { staticClass: "text-xs-center" },
                                      [_vm._v(_vm._s(props.item.jefe))]
                                    )
                                  ]
                                }
                              }
                            ])
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "secundary", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.close()
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("close")]),
                  _vm._v("\n        Cancelar\n      ")
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { color: "success", loading: _vm.loading },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.apruebaPermiso(_vm.permiso)
                    }
                  }
                },
                [
                  _c("v-icon", [_vm._v("check")]),
                  _vm._v("\n        Aprobar\n      ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a962ba1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a962ba1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/vacacion_uso/dialogs/AprobarPermiso.vue
// module id = null
// module chunks = 